module.exports = __webpack_public_path__ + "static/media/notification-check.9f3724ce.svg";